import { END_POINTS } from "../constants/url";
import { Category, Sub_Category } from "../types/General";
import { CATEGORY_TYPE } from "../utils/enums";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};

export const categoryApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<
      CommonResponseType,
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.category}?type=${CATEGORY_TYPE.CATEGORY}&page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
    getCategoryById: builder.query<
      CommonResponseType,
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "GET",
      }),
    }),
    addCategory: builder.mutation<CommonResponseType, { data: Category }>({
      query: (body) => ({
        url: END_POINTS.category,
        method: "POST",
        body: body?.data,
      }),
    }),
    updateCategory: builder.mutation<
      CommonResponseType,
      { id: string; body: Category },
      {
        id: string;
      }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "PUT",
        body: body,
      }),
    }),
    deleteCategory: builder.query<
      CommonResponseType,
      { id: string },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "DELETE",
      }),
    }),

    // subCategory
    getSubCategory: builder.query<
      CommonResponseType,
      { parentId: string; page: number; limit: number; search: string }
    >({
      query: ({ parentId, page, limit, search }) => ({
        url: `${END_POINTS.category}?parentId=${parentId}&type=${CATEGORY_TYPE.SUB_CATEGORY}&page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
    addSubCategory: builder.mutation<
      CommonResponseType,
      { data: Sub_Category }
    >({
      query: (body) => ({
        url: END_POINTS.category,
        method: "POST",
        body: body?.data,
      }),
    }),
    updateSubCategory: builder.mutation<
      CommonResponseType,
      { id: string; body: Category },
      {
        id: string;
      }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "PUT",
        body: body,
      }),
    }),
    subCategoryDeleteCategory: builder.query<
      CommonResponseType,
      { id: string },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "DELETE",
      }),
    }),
    getMasterData: builder.query<
      CommonResponseType,
      { parentId: string; type: number }
    >({
      query: ({ parentId, type }) => ({
        url: `${END_POINTS.masterData}?parentId=${parentId}&type=${type}`,
        method: "GET",
      }),
    }),

    reorderingApi: builder.mutation<CommonResponseType, any>({
      query: (body) => ({
        url: END_POINTS.reorderCategory,
        method: "POST",
        body,
      }),
    }),
  }),
});
export const {
  useLazyGetCategoryQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useLazyDeleteCategoryQuery,
  useLazyGetCategoryByIdQuery,

  //subCategory
  useAddSubCategoryMutation,
  useLazyGetSubCategoryQuery,
  useUpdateSubCategoryMutation,
  useLazySubCategoryDeleteCategoryQuery,
  useLazyGetMasterDataQuery,
  useReorderingApiMutation,
} = categoryApi;
